import { ParamMap } from '@angular/router';

export function routeId(params: ParamMap, name: string): number | undefined {
  const id = Number(params.get(name));
  return Number.isInteger(id) && id > 0 ? id : undefined;
}
